import { withSearch } from '@elastic/react-search-ui';
import MultiCheckboxFilter from '../../../components/filter/MultiCheckboxFilter';

function TeachingActivitiesPeriodFilter({
  addFilter,
  removeFilter,
  facets,
  filters,
}) {
  return (
    <MultiCheckboxFilter
      addFilter={addFilter}
      facets={facets}
      fieldId="period"
      filters={filters}
      formHint="Select all that apply."
      id="period"
      label="Periods"
      orderByCount={false}
      removeFilter={removeFilter}
    />
  );
}

export default withSearch(({ addFilter, removeFilter, facets, filters }) => ({
  addFilter,
  removeFilter,
  facets,
  filters,
}))(TeachingActivitiesPeriodFilter);
